import _ from "lodash";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FriendFriended, User } from "src/lib/slices/userSlice";
import { cn } from "src/lib/utils";
import useSWR from "swr";
import Indicator from "../Indicator";
import UserSettings from "../UserSettings";
import UserAvatar from "../userAvatar";

const fetcher = (token) => async (url) => {
  const res = await fetch(url, { headers: { Authorization: token } });

  return res.json();
};

const Wrapper = ({ children, className, userId }) => {
  const user: User = useSelector((state: any) => state.user);

  if (user.id === userId) {
    return (
      <UserSettings asChild>
        <div className={cn("cursor-pointer", className)}>{children}</div>
      </UserSettings>
    );
  }

  return (
    <Link to={`/user/${userId}`} className={className}>
      {children}
    </Link>
  );
};

export function FriendTag({
  userId,
  className,
}: {
  userId: string;
  className?: string;
}) {
  const user = useSelector((state: any) => state.user);

  const { data } = useSWR<FriendFriended>(
    `${process.env.REACT_APP_API_URL}/users/by-id/${userId}`,
    fetcher(user.token)
  );

  if (!data) return null;

  return (
    <Wrapper
      userId={userId}
      className={cn("flex items-center gap-1", className)}
    >
      <UserAvatar friend={data} className="h-4 w-4" />
      <div
        style={{ lineHeight: "1rem" }}
        className={!data.name ? "text-muted-foreground" : ""}
      >
        {data.name ?? "Beze jména"}
      </div>
    </Wrapper>
  );
}

export default function FriendChip({ userId }: { userId: string }) {
  const user = useSelector((state: any) => state.user);

  const { data } = useSWR<FriendFriended>(
    `${process.env.REACT_APP_API_URL}/users/by-id/${userId}`,
    fetcher(user.token)
  );

  if (!data) return null;

  return (
    <Wrapper
      className="flex flex-col items-center relative max-w-fit gap-0.5"
      userId={userId}
    >
      {_.isNumber(data.permille) && (
        <div
          style={{
            height: "1.5rem",
            position: "absolute",
            left: "2.5rem",
            top: "-0.5rem",
          }}
        >
          <Indicator
            doNotDisplayText
            value={data.permille}
            maxValue={data.maxPermille}
          />
        </div>
      )}
      <UserAvatar friend={data} className="h-12 w-12" />
      <div className="flex flex-col items-center">
        <div
          style={{
            width: "3rem",
            fontSize: "0.70rem",
            textWrap: "nowrap",
            textOverflow: "clip",
            overflow: "hidden",
            whiteSpace: "nowrap",
            lineHeight: "0.75rem",
            textAlign: "center",
          }}
        >
          {data.name}
        </div>
        {_.isNumber(data?.permille) && (
          <div
            style={{
              color: "hsl(var(--muted-foreground))",
              fontSize: "0.75rem",
              lineHeight: "0.75rem",
            }}
          >
            {data.permille} ‰
          </div>
        )}
      </div>
    </Wrapper>
  );
}
